import React from 'react'
import Measurement from './Measurement'
import { Rect, Side } from 'modules/shares/types'
import CSS from 'csstype'
import theme from 'styles/theme'

const Line: React.FC<{
  measurement: Measurement
  side: Side
}> = ({ measurement, side }) => {
  const frame: Rect = {
    x: Math.min(measurement.startPoint.x, measurement.endPoint.x),
    y: Math.min(measurement.startPoint.y, measurement.endPoint.y),
    width: measurement.axis === 'x' ? measurement.length : 1,
    height: measurement.axis === 'y' ? measurement.length : 1,
  }

  const style: CSS.Properties = {
    position: 'absolute',
    background: theme.colors.azure,
    left: `${frame.x}px`,
    top: `${frame.y}px`,
    width: `${frame.width}px`,
    height: `${frame.height}px`,
  }

  return <div style={style} data-testid={`line-${side}`} />
}
export default Line
